import nextCookie from "next-cookies";
import Head from "next/head";

import { menuCategoriesApi, cartApi } from "../../services/api";
import CTA from "../../components/CTA";
import ClipLoader from "react-spinners/ClipLoader";
import SidebarPage from "../../components/SidebarPage";
import ProductList from "../../components/ProductList";
import Pagination from "../../components/Pagination";
import {Loading} from "../../styles/busca";
import { useCart } from "../../components/CartContext";
import { useUser } from "../../components/UserContext";


const Categoria = ({ line, products, pages, token, cart_token, categorySlug, subcategorySlug}) => {
  const [loading, setLoading] = React.useState(false);

  async function loadScreen(isLoading){
    setLoading(isLoading);
    setTimeout(() => {
      setLoading(false)
    }, 5000)
}
  const { cart, setCart } = useCart();
  const { user } = useUser();

  async function add_products_to_cart()
  {
    
    const newCart = await cartApi.itensFromCategories({ user_token: token, cart_token, id: categorySlug, parent_id: subcategorySlug, page: 99999 });
    setCart(newCart);

  }

  return (
    <>
    {loading ?
      <Loading>
        <ClipLoader color={'#F37A24'} loading={loading} size={80} />
      </Loading>
      :
      ""
    } 
    <SidebarPage token={token} loadScreen={loadScreen}>
      <Head>
        <title key="title">{line.name} | Goods Br</title>
        <meta
          key="og-title"
          property="og:title"
          content={`${line.name} | Goods Br`}
        />
      </Head>
      <ProductList title={line.name} products={products} video={line.video} description={line.video_description} cart_token={cart_token}>
        <div>
          {/* {
           ( user?.company_user == true ) && 
            (
              <CTA button onClick={e => add_products_to_cart() }>
                Adicionar produtos categoria ao carrinho.
              </CTA>
            )
          } */}
          
        </div>
        <Pagination pages={pages} templateHref={`/linha/[...slug]`} />
      </ProductList>
    </SidebarPage>
    </>
  );
};

Categoria.getInitialProps = async ctx => {
  const { token, outlet_cookie, nacional_cookie, internacional_cookie, lancamento_cookie, lancamentoLT_cookie, saldos_cookie, noImage_cookie, cart_token } = nextCookie(ctx);

  const { slug, page } = ctx.query;
  const [categorySlug, subcategorySlug] = slug;

  const { products, line, pages } = await menuCategoriesApi.get(
    categorySlug,
    { user_token: token, page, outlet_cookie, nacional_cookie, internacional_cookie, lancamento_cookie, lancamentoLT_cookie, saldos_cookie, noImage_cookie }
  );
  
  return {
    products,
    pages,
    token,
    outlet_cookie, nacional_cookie, internacional_cookie, lancamento_cookie, lancamentoLT_cookie, saldos_cookie, noImage_cookie,
    cart_token,
    categorySlug,
    subcategorySlug,
    line
  };
};

export default Categoria;